import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { liability } from '../../../../functions/claim/liability';
import { Action } from '../../../../models/core/action';
import { BaseComponent } from '../../../base/base.component';
import { SelectComponent } from '../../../core/controls/select.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { TabPanelComponent } from '../../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../../core/panels/tab-panel/tab.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { PaymentSummaryTabComponent } from './overview-payment-summary-tab.component';
import { ReimbursablesTabComponent } from './overview-reimbursables-tab.component';
import { OverviewTabComponent } from './overview-tab.component';

@Component({
  selector: 'app-overview',
  imports: [
    RouterModule,
    PageHeaderComponent,
    SelectComponent,
    TabPanelComponent,
    TabComponent,
    OverviewTabComponent,
    TableComponent,
    ColumnComponent,
    CardComponent,
    DetailPanelComponent,
    DetailItemComponent,
    ReimbursablesTabComponent,
    PaymentSummaryTabComponent,
  ],
  template: `
    <app-page-header label="Overview">
      <ng-template #right>
        <app-select
          [options]="levels"
          optionLabel="label"
          optionValue="key"
          [virtualScroll]="false"
          [control]="level"
          label="View"
          [multiple]="false"
          [filter]="false"
          [showClear]="false"
          [showHelpText]="false"
          class="tw-basis-full sm:tw-basis-1/5 tw-min-w-0"
        />
      </ng-template>
    </app-page-header>
    <app-tab-panel class="tw-grow" classes="tw-min-h-[360px]">
      <app-tab label="Overview">
        <ng-template #content>
          <app-overview-tab [level]="level" [liability]="liability" />
        </ng-template>
      </app-tab>
      @if (showPaymentSummary) {
        <app-tab label="Payment summary">
          <ng-template #content>
            <app-overview-payment-summary-tab
              [level]="level"
              [liability]="liability"
            />
          </ng-template>
        </app-tab>
      }
      <app-tab label="Reimbursables">
        <ng-template #content>
          <app-overview-reimbursables-tab [level]="level" />
        </ng-template>
      </app-tab>
      @if (!workersComp && !liability) {
        <app-tab label="Recoveries">
          <ng-template #content>
            <div
              class="tw-flex tw-flex-col sm:tw-flex-row tw-basis-full tw-gap-8"
            >
              <div class="tw-basis-full sm:tw-basis-1/3 tw-min-w-0">
                <app-card label="Receivables">
                  <app-detail-panel [dataSource]="items[0]">
                    <app-detail-item label="Paid" name="dollars" />
                    <app-detail-item label="Expected" name="dollars" />
                  </app-detail-panel>
                </app-card>
              </div>
              <div class="tw-basis-full sm:tw-basis-2/3 tw-min-w-0">
                <app-card label="NCCI">
                  <app-table
                    [dataSource]="items"
                    [pageSize]="5"
                    [scrollable]="false"
                    dataKey="id"
                    recordLabel="item"
                  >
                    <app-column name="age" label="Recovery type" />
                    <app-column name="value" label="Indemnity/loss" />
                    <app-column name="dollars" label="Medical" format="c" />
                    <app-column name="dollars" label="Expense" format="c" />
                    <app-column name="dollars" label="Other" format="c" />
                    <app-column name="dollars" label="Total" format="c" />
                  </app-table>
                </app-card>
              </div>
            </div>
          </ng-template>
        </app-tab>
        <app-tab label="Reimursables">
          <ng-template #content>
            <div
              class="tw-flex tw-flex-col sm:tw-flex-row tw-basis-full tw-gap-8"
            >
              <div class="tw-basis-full sm:tw-basis-2/3 tw-min-w-0">
                <app-card label="Reimbursements">
                  <app-table
                    [dataSource]="items"
                    [pageSize]="5"
                    [scrollable]="false"
                    dataKey="id"
                    recordLabel="Reimbursement"
                  >
                    <app-column name="value" label="Description" />
                    <app-column name="dollars" label="Amount*" format="c" />
                    <app-column name="dollars" label="Recovered" format="c" />
                    <app-column name="dollars" label="Outstanding" format="c" />
                  </app-table>
                  * Includes paid and scheduled
                </app-card>
              </div>
            </div>
          </ng-template>
        </app-tab>
      }
    </app-tab-panel>
  `,
  styles: ``,
})
export class OverviewComponent extends BaseComponent implements OnInit {
  level = new FormControl<string>('claim');
  disability = false;
  workersComp = false;
  liability = false;
  claim: any = {};

  // Payment Summary tab visibility controlled by security token
  showPaymentSummary = false;

  levels: Action[] = [
    { key: 'claim', label: 'Claim' },
    { key: 'Claimant', label: 'Claimant' },
    { key: 'Event', label: 'Event' },
  ];

  // Mock data
  items: any[] = [];

  ngOnInit() {
    this.view.hideLoading();
    this.claim = this.view.currentClaim();
    this.disability = this.claim.lineOfBusiness === 'DS';
    this.workersComp = this.claim.lineOfBusiness === 'WC';
    this.liability = liability(this.claim.lineOfBusiness);

    // Check security token for Payment Summary tab
    this.showPaymentSummary = this.session.authorize('PaymentSummary');
  }
}
